export function updateQueryStringParameter(params: Array<string[]>) {
    const searchParams = new URLSearchParams();
    params.forEach(it => searchParams.set(it[0], it[1]));
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + searchParams.toString();
    window.history.replaceState(null, null as any, newurl);
}
